"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockTechniqueKeyword = void 0;
function mockTechniqueKeyword(overrides = {}) {
    return {
        category: 'rods',
        description: '<p>lorem</p>\r\n',
        featured: false,
        keyword_text: 'rods and chatterbaits',
        slug: 'rods-chatterbaits',
        style: 'chatterbaits',
        subcategory: null,
        technique: 'chatterbaits',
        ...overrides,
    };
}
exports.mockTechniqueKeyword = mockTechniqueKeyword;
